export enum ReportSortOption {
  sortCropFieldName = 'sortCropFieldName',
  sortCropName = 'sortCropName',
}

export interface ReportSort {
  option: ReportSortOption;
  descending: boolean;
}

export enum ReportSortButtonAction {
  sortOptions = 'sortOptions',
  sortDirection = 'sortDirection',
}

export interface ReportSorterRequest<T> {
  elements: T[];
  option: ReportSortOption;
  descending: boolean;
  cropFieldNameFunc: (x: T) => string;
  cropNameFunc: (x: T) => string;
}
